import React from "react";
import { observer } from "mobx-react";
import { SignedEditionBlockchainCertViewStore } from "../../store";
import { SignedEditionBlockchainCertViewForm } from "./SignedEditionBlockchainCertViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type SignedEditionBlockchainCertViewProps = {
  signedEditionBlockchainCertViewStore: SignedEditionBlockchainCertViewStore;
};

export const SignedEditionBlockchainCertView: React.FC<SignedEditionBlockchainCertViewProps> =
  observer(({ signedEditionBlockchainCertViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <SignedEditionBlockchainCertViewForm
          name={signedEditionBlockchainCertViewStore.nameValue}
          contractNumber={
            signedEditionBlockchainCertViewStore.contractNumberValue
          }
          fileFiles={signedEditionBlockchainCertViewStore.fileFiles}
          confirmedAt={signedEditionBlockchainCertViewStore.confirmedAtValue}
          onPrint={(handlePrint: () => void) =>
            signedEditionBlockchainCertViewStore.printSignedEditionBlockchainCert(
              handlePrint
            )
          }
          onCancel={() =>
            signedEditionBlockchainCertViewStore.cancelSignedEditionBlockchainCert()
          }
          onEdit={
            signedEditionBlockchainCertViewStore.isEditEnabled
              ? () =>
                  signedEditionBlockchainCertViewStore.editSignedEditionBlockchainCert()
              : undefined
          }
          fileViewAction={getViewAction(
            (props) =>
              signedEditionBlockchainCertViewStore.fileDownload(props, "file"),
            (props) =>
              signedEditionBlockchainCertViewStore.viewFilePdf(props, "file")
          )}
        />
        <ErrorDialog
          open={signedEditionBlockchainCertViewStore.errorDialogOpened}
          title={signedEditionBlockchainCertViewStore.errorTitle}
          description={signedEditionBlockchainCertViewStore.errorDescription}
          onClose={() =>
            signedEditionBlockchainCertViewStore.closeErrorDialog()
          }
        />
        <PDFViewerDialog
          open={signedEditionBlockchainCertViewStore.pdfViewerOpen}
          onClose={() => signedEditionBlockchainCertViewStore.closePdfViewer()}
          pdfUrl={signedEditionBlockchainCertViewStore.pdfViewerUrl}
          title={signedEditionBlockchainCertViewStore.pdfViewerTitle}
        />
      </div>
    );
  });
